import React, { useMemo } from 'react';
import classNames from 'classnames';
import styles from './CircleWithShadow.module.scss';

const CircleWithShadow = ({
  src,
  title = '',
  rendered,
  additionalClass
}) => {
  const classes = useMemo(() => {
    return (
      classNames({
        [styles.CircleWithShadow]: true,
        [additionalClass]: !!additionalClass,
        [styles[title.toLowerCase()]]: !!title,
        [styles.rendered]: rendered,
      }));
  }, [styles, additionalClass, title, rendered]);

  return (
    <div className={ styles.wrapper }>
      <div className={ styles.title }>
        {title}
      </div>
      <div className={ classes }>
        <img src={src} alt="icon" />
      </div>
    </div>
  );
};

export default CircleWithShadow;
